/**
 * Footer variants that are their own component. Anything not listed renders
 * through the original Footer.tsx, which handles the four founding variants
 * with internal branching. Adding a footer design = one file + one line here;
 * the knob value itself lives in the registry package (KNOB_VALUES).
 */
import type { ComponentType } from 'react';
import type { FooterVariant } from '@/looks';
import type { FooterProps } from '../Footer';
import AppFooter from './AppFooter';

export const FOOTER_VARIANT_COMPONENTS: Readonly<Partial<Record<FooterVariant, ComponentType<FooterProps>>>> = {
  app_footer: AppFooter,
};
